import { render, staticRenderFns } from "./Page_SingleDiscountPartner.vue?vue&type=template&id=037468c6&scoped=true&"
import script from "./Page_SingleDiscountPartner.vue?vue&type=script&lang=js&"
export * from "./Page_SingleDiscountPartner.vue?vue&type=script&lang=js&"
import style0 from "./Page_SingleDiscountPartner.vue?vue&type=style&index=0&id=037468c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037468c6",
  null
  
)

export default component.exports